<template>
  <div>
      <div class="main_div">
        <v-card>
          <ul v-if="!phone">
            <li>{{ $t('info.orde') }}: {{orde}}</li>
            <li>{{ $t('info.familie') }}: {{familie}}</li>
            <li>{{ $t('info.lengte') }}: {{lengte_van}} cm - {{lengte_tot}} cm</li>
          </ul>
          <ul v-if="phone" class="phone-size">
            <li>{{ $t('info.orde') }}: {{orde}}</li>
            <li>{{ $t('info.familie') }}: {{familie}}</li>
            <li>{{ $t('info.lengte') }}: {{lengte_van}} cm - {{lengte_tot}} cm</li>
          </ul>
          <v-expansion-panels class="expansion" flat>
            <v-expansion-panel>
              <v-expansion-panel-header v-if="!phone">{{ $t('info.omschrijving') }}</v-expansion-panel-header>
              <v-expansion-panel-header v-if="phone" class="phone-size">{{ $t('info.omschrijving') }}</v-expansion-panel-header>
              <v-expansion-panel-content v-if="!phone" >{{ omschrijving }}</v-expansion-panel-content>
              <v-expansion-panel-content v-if="phone" class="phone-size">{{ omschrijving }}</v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </div>
    </div>
</template>

<script>
export default {
  name: "PhotoInfo",
  data() {
    return {
      species: this.$route.params.species
    };
  },
  props: {
    orde: String,
    familie: String,
    lengte_van: Number,
    lengte_tot: Number,
    omschrijving: String,
    phone: Boolean
  },
  computed: {
    specie() {
      return this.$store.state.specie;
    }
  },
  mounted() {
    this.$store.dispatch("getSpecie");
  },
  specie() {
    return this.$store.state.specie;
  },
  methods: {
    updateSpecies() {
      this.species = this.$route.params.species;
    }
  },
  watch: {
    $route: "updateSpecies"
  }
};
</script>

<style scoped>
.main_div {
  width: 100%;
}

.expansion {
  width: 100%;
}
.phone-size{
  font-size: 75%;
}
</style>